import clsx from 'clsx';
import type { ReactNode } from 'react';
import { Link as RACLink } from 'react-aria-components';
import type { NavigationProps, StringLikeChildren, WithRequired } from '../types.js';
import { Text } from '../typography/text.js';

export interface UNSTABLE_TopNavProps {
  children: ReactNode;
}

export function UNSTABLE_TopNav({ children }: UNSTABLE_TopNavProps) {
  return (
    <nav className={clsx('cim-top-nav', 'cim-link-tabs')}>
      <ul className="cim-tab-list">{children}</ul>
    </nav>
  );
}

export interface UNSTABLE_TopNavItemProps extends WithRequired<NavigationProps, 'href'> {
  children: StringLikeChildren;
  isActive?: boolean;
}

export function UNSTABLE_TopNavItem({ children, href, isActive, ...props }: UNSTABLE_TopNavItemProps) {
  return (
    <li>
      <RACLink
        {...props}
        className={clsx('cim-tab-item', 'cim-link-tab-item')}
        href={href}
        aria-current={isActive ? 'page' : undefined}
        data-selected={isActive || undefined}
      >
        <Text as="span" variant="medium-semibold" alignment="center">
          {children}
        </Text>
      </RACLink>
    </li>
  );
}
